import React, { createElement } from 'react';
const Image = (props, ref) => {
    return createElement("img", Object.assign({}, props, { ref: ref }));
};
const RefImage = React.forwardRef(Image);
RefImage.defaultProps = {
    src: 'https://img.alicdn.com/tps/TB16TQvOXXXXXbiaFXXXXXXXXXX-120-120.svg',
};
export default RefImage;
